import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { AIIcon, Message, MessageContainer, Timestamp } from './styles';
import { ReportViewer } from '@/components/molecules/reportViewer';
import { SparklesIcon } from '@/components/atoms/customIcons/sparklesIcon';
import { SafeMarkdown } from '@/components/atoms/markdown/safe';

interface ChatMessageProps {
  role: 'user' | 'assistant';
  content: string;
  timestamp?: string;
}

export const ChatMessage = ({ role, content, timestamp }: ChatMessageProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        alignSelf: role === 'user' ? 'flex-end' : 'flex-start',
      }}
    >
      <MessageContainer>
        {role === 'assistant' && (
          <AIIcon>
            <SparklesIcon color="primary" />
          </AIIcon>
        )}

        <Message
          sx={{
            bgcolor: role === 'user' ? theme.palette.primary.dark : '#e0e0e0',
            color: role === 'user' ? 'white' : 'black',
          }}
        >
          <Box
            sx={{
              fontSize: '0.875rem',
              lineHeight: 1.43,
              letterSpacing: '0.01071em',
            }}
          >
            <ReportViewer reportText={content} />
          </Box>

          {timestamp && (
            <Timestamp
              variant="caption"
              sx={{
                alignSelf: role === 'user' ? 'flex-end' : 'flex-start',
              }}
            >
              <SafeMarkdown text={timestamp} />
            </Timestamp>
          )}
        </Message>
      </MessageContainer>
    </Box>
  );
};
